import { getToken } from "firebase/messaging"
import { messaging } from "../configs/firebase"
import { useApi } from "./api"

export const useNotification = () => {
    const { $post, $get, objToArray } = useApi()

    const getFcmToken = async () => {
        // const token = await getToken(messaging, { vapidKey: "BOuNhdd-10rqvHU7bbYWnCbQPDolQknyfEGm7ml9Sm2DkOyAbuqJN5r81i1NwoN_h2moTb9_O-X43iRE4Uts7xs" })
        // console.log('token', token)
        // const res = await $post('backend/account/device/', { token }, false)
        // return res;
        return null
    }

    const getNotifications = async (req: { start_date?: string; end_date?: string; year?: number; month?: number; day?: number; }) => {
        const data = await $get('backend/account/notification/', req)
        if (data && (data.res.toLowerCase() === 'success' || data.res.toLowerCase() === 'failed')){
            return data
        }
        return 
    }

    const setNotificationAsRead = async (notification_id: string) => {
        return await $post('backend/mark_notification_read/', { notification_id }, false)
    }

    return {
        getFcmToken,
        getNotifications,
        setNotificationAsRead
    }
}